

// src/components/Footer.jsx
import React from "react";
import { FaInstagram, FaFacebookF, FaLinkedinIn } from "react-icons/fa";
import "../styles/footer.css";

export default function Footer() {
  return (
    <footer className="footer-cp">
      <div className="footer-overlay" />

      <div className="cp-container">
        {/* GRID */}
        <div className="footer-grid">
          
          {/* COLUMN 1: BRAND */}
          <div className="footer-col brand-col">
            <img
              src="/images/concertedlg.png"
              alt="Concerted Path"
              className="footer-logo"
            />

            <h3 className="footer-brand-title">Concerted Path</h3>

            <p className="footer-desc">
              Concerted Path is a leading accounting & commerce training institute
              focused on practical learning, industry exposure, and assured
              placement support to make students job-ready.
            </p>
          </div>

          {/* COLUMN 2: IMPORTANT LINKS */}
          <div className="footer-col">
            <h4 className="footer-heading">Important Links</h4>
            <ul>
              <li><a href="/courses">Courses</a></li>
              <li><a href="/fees">Fees Structure</a></li>
              <li><a href="/placements">Placements</a></li>
              <li><a href="/verify">Certificate Verification</a></li>
              <li><a href="/about">About Us</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
          </div>

          {/* COLUMN 4: CONTACT */}
          <div className="footer-col">
            <h4 className="footer-heading">Contact</h4>

            <p>
              Logix City Centre, 7th Floor<br />
              Plot No. BW-58, Sector-32<br />
              Noida, U.P. India
            </p>

            <p>
              <strong>Phone:</strong> +91 9650004929<br />
              <strong>Email:</strong>{" "}
              <a href="mailto:support@concertedpath.com">
                support@concertedpath.com
              </a>
            </p>
            <div className="footer-social-wrapper">
               <div className="footer-social-title">Follow Us</div>
                 <div className="footer-social">
                 <a href="#"><FaInstagram /></a>
                 <a href="#"><FaFacebookF /></a>
                <a href="#"><FaLinkedinIn /></a>
                </div>
            </div>
          </div>

        </div>

        {/* BOTTOM */}
        <div className="footer-bottom">
          © {new Date().getFullYear()} Concerted Path. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
